exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".adjacent-target[data-target=\"external_target\"]{background:transparent}\n", ""]);

